/* unplugin-vue-components disabled */import { render } from "./ActivityCreate.vue?vue&type=template&id=2c48d032&scoped=true"
import script from "./ActivityCreate.vue?vue&type=script&lang=js"
export * from "./ActivityCreate.vue?vue&type=script&lang=js"

import "./ActivityCreate.vue?vue&type=style&index=0&id=2c48d032&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c48d032"]])

export default __exports__